export default __webpack_public_path__ + "static/media/quemsomos.aed4d927.jpg";